export { default } from './InfoBanner'
export type { InfoBannerProps } from './InfoBanner.types'
